import { render, staticRenderFns } from "./tabbed-info.vue?vue&type=template&id=110ca9ce"
import script from "./tabbed-info.vue?vue&type=script&lang=js"
export * from "./tabbed-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports